/**
 * The interpreter's Add Call (a third or fourth hearing party on the phone
 * conference, the Tools panel Phone section's "Add hearing party"): what each outcome says, in a
 * few words (MCG UI Standard: what failed and the way out), never the
 * server's own sentence. Codes come from POST /api/interpreter/voice/call
 * (vrs-server routes/interpreter.js) and the outbound phone policy
 * (shared/outbound-phone-policy.js).
 */
const I18N_ROOT = 'vrs.invite.hearing';
const FAILURE_KEYS = {
    OUTBOUND_COUNTRY_NOT_ALLOWED: 'countryBlocked',
    OUTBOUND_PHONE_BLOCKED: 'numberBlocked',
    OUTBOUND_PHONE_INVALID: 'invalidNumber',
    OUTBOUND_PHONE_TYPE_BLOCKED: 'numberBlocked',
    OUTBOUND_REGION_NOT_ALLOWED: 'countryBlocked',
    VALIDATION_ERROR: 'invalidNumber'
};
/**
 * Why Add Call did not dial; anything unnamed is worth another try. The other
 * Add Call lines (dialing, added, dropped) are the Phone section's own
 * vrs.tools.* words, on the web and in Terp alike.
 */
export function hearingPartyAddFailureText(code, t) {
    return String(t(`${I18N_ROOT}.${FAILURE_KEYS[code || ''] || 'failed'}`));
}
